import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'

export const DeleteFirstEmptyParagraphPlugin = new Plugin({
  key: new PluginKey('deleteFirstEmptyParagraph'),

  props: {
    handleKeyDown(view, event) {
      const { state, dispatch } = view
      const { selection, doc } = state

      // Solo actúa en Backspace
      if (event.key !== 'Backspace') return false

      const { from, to } = selection

      // Solo si el cursor está al principio del documento (posición 1)
      if (from !== to || from !== 1) return false

      const firstNode = doc.firstChild

      if (!firstNode || firstNode.type.name !== 'paragraph') return false

      // Verificamos que esté vacío
      if (firstNode.content.size > 0) return false

      // Borramos el nodo (posición 0 a su tamaño)
      const tr = state.tr.delete(0, firstNode.nodeSize)
      dispatch(tr)
      return true
    },
  },
})

export const DeleteFirstEmptyParagraphExtension = Extension.create({
  name: 'deleteFirstEmptyParagraph',
  addProseMirrorPlugins() {
    return [DeleteFirstEmptyParagraphPlugin]
  },
})
